// /Page/Element — one entry of a page's ordered `elements` array.
//
// Ported from the archived project's @repoflow/schema/page-element.
import TypesSchema from "@common/schema/types";
import * as ElementTypes from "./types";

import {
  elementid,
  name,
  type,
  frame,
  tags,
  config,
  translationPending,
} from "./fields";

export default [
  ...TypesSchema,
  ...ElementTypes.schema,
  {
    id: "/Page/Element",
    type: "object",
    properties: {
      elementid,
      name,
      type,
      frame,
      tags,
      config,
      translationPending,
    },
    required: ["type"],
  },
];
